import { z } from "zod";
import { InputField, FormSubmitCallback, FormBase } from "ui/Form";
import { FieldProps } from "react-final-form";
import { useMutation } from "@apollo/client";
import { EditStudentParentEmailMutation, EditStudentParentEmailMutationVariables, EDIT_STUDENT_PARENT_EMAIL, Student, StudentDataType } from "ft-shared-graphql";
const EMAIL_FORM_FIELDS: FieldProps<string, any>[] = [
    {
        name: 'email',
        label: 'Email',
        component: InputField,
        required: true,
        fullWidth: true,
        grid: {
            xs: 12,
        },
    }
];

const emailValidationSchema = z.object({
    email: z.string().email("Invalid email")
});

export type EmailFormSchema = z.infer<typeof emailValidationSchema>;

export type EmailFormProps = {
    onSubmit: (values: EmailFormSchema) => Promise<ReturnType<FormSubmitCallback>>
}

export default function EmailForm({ onSubmit }: EmailFormProps) {

    return FormBase<EmailFormSchema>({
        fields: EMAIL_FORM_FIELDS,
        initialValues: {},
        validationSchema: emailValidationSchema,
        buttonSubmitLabel: "Submit",
        onSubmit: onSubmit,
        onCancel: null
    });
}

